<template>
    <div class="inner-container">
        <div class="table-container">
            <b-table
                :fields="tableFields"
                :items="goodsData"
                responsive="true"
                bordered
                head-variant="light"
                sticky-header="true"
                no-border-collapse
            >
                <template #head(more)>
                    <div class="text-center">
                        <i
                            :title="getCommonText('del_selected')"
                            class="icon icon-close table-all-remove"
                            @click="
                                deleteItem(
                                    `${
                                        selectAllGoods
                                            ? getDecText('del_all_recs')
                                            : getDecText('del_selected_recs')
                                    }`
                                )
                            "
                        />
                    </div>
                </template>
                <template #top-row="data">
                    <td></td>
                    <td class="td-numbering table-success text-center">1</td>
                    <td class="td-numbering table-danger text-center">2</td>
                    <td class="td-numbering table-info text-center">3</td>
                    <td class="td-numbering table-primary text-center">4</td>
                    <td class="td-numbering table-warning text-center">5</td>
                    <td class="td-numbering table-success text-center">6</td>
                    <td class="td-numbering table-danger text-center">7</td>
                    <td></td>
                </template>
                <template #head(action)>
                    <div class="text-center">
                        <b-form-checkbox
                            v-model="selectAllGoods"
                            @change="
                                (e) => $emit('setIsAllDelete', e, goodsData)
                            "
                            :value="true"
                            :unchecked-value="false"
                        />
                    </div>
                </template>

                <template #cell(action)="data">
                    <b-form-checkbox
                        v-model="data.item.itemToDelete"
                        @input="
                            (e) => {
                                if (!e) selectAllGoods = false;
                            }
                        "
                        :value="true"
                        :unchecked-value="false"
                    />
                </template>
                <template #cell(order_number)="data">
                    <div class="text-right">{{ $n(data.value) }}</div>
                </template>
                <template #cell(expense_code)="data">
                    <div
                        class="column-width-100"
                        :class="{
                            error:
                                variantAttribute &&
                                getDecodeControl(data.index).isDouble,
                        }"
                    >
                        <multiselect
                            v-if="variantAttribute"
                            v-model="data.item.curr_expense_code"
                            :label="`name_${lng_kz}`"
                            :placeholder="getFormText('select_project')"
                            :options="projectsBankFormData"
                            :searchable="true"
                            :allow-empty="false"
                            :show-labels="false"
                            @input="onExpenseCodeChanged(data.item)"
                        >
                        </multiselect>
                        <div v-else>
                            {{ data.item.curr_expense_code[`name_${lng_kz}`] }}
                        </div>
                        <p
                            class="goods-form-val-msg"
                            v-if="
                                variantAttribute &&
                                !data.item.curr_expense_code &&
                                isValErrShowed
                            "
                        >
                            {{ getCommonText("must_be_filled") }}
                        </p>
                        <template
                            v-if="
                                variantAttribute &&
                                getDecodeControl(data.index).isDouble
                            "
                        >
                            <i class="icon icon-danger"></i>
                            <div class="pop-up">
                                <p class="red-text">
                                    {{ getCommonText("not_valid") }}
                                </p>
                                <p>{{ getCommonText("exist") }}</p>
                            </div>
                        </template>
                    </div>
                </template>
                <template #cell(summa)="data">
                    <b-form-input
                        v-if="variantAttribute && data.item.curr_expense_code"
                        class="text-right number-input-width"
                        :value="data.item.summa"
                        @change="(v) => inputFixed(data.item, 'summa', v, 3)"
                        @keyup.enter.exact="keyup13"
                        @keypress="keyPress($event, '^\\d*\\.?\\d{0,9}$')"
                    >
                    </b-form-input>
                    <div v-else class="text-right">
                        {{ $n(data.value) }}
                    </div>
                    <p
                        class="goods-form-val-msg"
                        v-if="
                            variantAttribute &&
                            !data.item.summa &&
                            data.item.curr_expense_code
                        "
                    >
                        {{ getCommonText("positive") }}
                    </p>
                </template>

                <template #cell(recipient)="data">
                    <div class="column-width-100 bp-category-name">
                        <div>{{ data.item["recipient_" + lang] }}</div>
                        <i
                            v-if="variantAttribute && data.item.expense_code"
                            class="icon icon-pencil-edit thin-blue ml-3 pointer icon-18"
                            @click="
                                showEditModal(
                                    data.item,
                                    'setRecipientGoodsModal'
                                )
                            "
                        ></i>
                    </div>
                </template>
                <template #cell(purpose)="data">
                    <div class="column-width-100 bp-category-name">
                        <div>{{ data.item["purpose_" + lang] }}</div>
                        <i
                            v-if="variantAttribute && data.item.expense_code"
                            class="icon icon-pencil-edit thin-blue ml-3 pointer icon-18"
                            @click="
                                showEditModal(data.item, 'setPurposeGoodsModal')
                            "
                        ></i>
                    </div>
                    <p
                        class="goods-form-val-msg"
                        v-if="
                            variantAttribute &&
                            getDecodeControl(data.index).isPurposeRequired
                        "
                    >
                        {{ getCommonText("must_be_filled") }}
                    </p>
                </template>
                <template #cell(justif)="data">
                    <div class="column-width-100 bp-category-name">
                        <div>{{ data.item["justif_" + lang] }}</div>
                        <i
                            v-if="variantAttribute && data.item.expense_code"
                            class="icon icon-pencil-edit thin-blue ml-3 pointer icon-18"
                            @click="
                                showEditModal(data.item, 'setJustifGoodsModal')
                            "
                        ></i>
                    </div>
                </template>
                <template #cell(total)="data">
                    <div class="text-right">{{ $n(data.value) }}</div>
                </template>
                <template #cell(files)="data">
                    <span
                        class="blue pointer underline"
                        @click="onFilesClick(data.item)"
                        >({{
                            data.item.file_hash
                                ? data.item.file_hash.split(";").length
                                : 0
                        }})</span
                    >
                </template>
                <template #cell(more)="data">
                    <i
                        class="icon icon-clear table-remove"
                        :disabled="isLoad"
                        v-if="variantAttribute"
                        @click="
                            deleteItem(
                                `${getDecText('del_curr_rec')}`,
                                data.item,
                                data.index
                            )
                        "
                    ></i>
                </template>

                <template #bottom-row="data">
                    <td class="text-left" colspan="3">
                        {{ getCommonText("total") }}
                    </td>
                    <td class="text-right">{{ $n(summaTotal) }}</td>
                    <td colspan="5"></td>
                </template>
            </b-table>
            <modal-files-management
                ref="modalFilesManagement"
                :allFiles="allFiles"
                :variantAttribute="variantAttribute"
                @showFileUploadModal="showFileUploadModal"
                @setNewFileHash="setNewFileHash"
                @triggDownloadFile="triggDownloadFile"
                @triggDownloadAllFiles="triggDownloadAllFiles"
            ></modal-files-management>
            <c-set-b-f-category-name
                ref="setRecipientGoodsModal"
                :budgetForm="goodsData"
                :lng="lang"
                :getCommonText="getCommonText"
                :categoryFieldNames="{ ru: 'recipient_ru', kk: 'recipient_kk' }"
                :maxNameLengthSymbls="500"
                :title="this.getFormText('recipient')"
                :textareaTitleRu="
                    this.getFormText('recipient_textarea_title_ru')
                "
                :textareaTitleKk="
                    this.getFormText('recipient_textarea_title_kk')
                "
                :placeHolder="this.getFormText('recipient_placeholder')"
                :canBeEmpty="true"
                :isDoublesCheckNeeded="false"
                @saveItem="onRowChanged"
            />
            <c-set-b-f-category-name
                ref="setPurposeGoodsModal"
                :budgetForm="goodsData"
                :lng="lang"
                :getCommonText="getCommonText"
                :categoryFieldNames="{ ru: 'purpose_ru', kk: 'purpose_kk' }"
                :maxNameLengthSymbls="500"
                :title="this.getFormText('purpose')"
                :textareaTitleRu="this.getFormText('purpose_textarea_title_ru')"
                :textareaTitleKk="this.getFormText('purpose_textarea_title_kk')"
                :placeHolder="this.getFormText('purpose_placeholder')"
                :canBeEmpty="true"
                :isDoublesCheckNeeded="false"
                @saveItem="onRowChanged"
            />
            <c-set-b-f-category-name
                ref="setJustifGoodsModal"
                :budgetForm="goodsData"
                :lng="lang"
                :getCommonText="getCommonText"
                :categoryFieldNames="{ ru: 'justif_ru', kk: 'justif_kk' }"
                :maxNameLengthSymbls="500"
                :title="this.getFormText('justif')"
                :textareaTitleRu="this.getFormText('justif_textarea_title_ru')"
                :textareaTitleKk="this.getFormText('justif_textarea_title_kk')"
                :placeHolder="this.getFormText('justif_placeholder')"
                :canBeEmpty="true"
                :isDoublesCheckNeeded="false"
                @saveItem="onRowChanged"
            />
        </div>
    </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import ModalFilesManagement from "./modal-files-management.vue";
import BpI18nHandlerMixin from "../mixins/bp-i18n-handler-mixin";
import CSetBFCategoryName from "./c-set-bf-category-name.vue";

export default {
    name: "FormTemplate10",
    components: {
        ModalFilesManagement,
        CSetBFCategoryName,
    },
    mixins: [BpI18nHandlerMixin],
    props: {
        goodsData: Array,
        variantAttribute: Boolean,
        currCategory: Object,
        lang: String,
        lng_kz: String,
        showFileUploadModal: Function,
        triggDownloadFile: Function,
        triggDownloadAllFiles: Function,
        allFiles: Array,
        isLoad: Boolean,
        projectsBankFormData: Array,
        isValErrShowed: Boolean,
        decodeControl: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            dataTypeFilter: null,
            variantName: null,
            formFilter: null,
            budgetForm: [],
            dict: [],
            files: null,
            load: false,
            openDisabled: false,
            currUnit: null,
            currGoodName: null,
            totalTotalSaved: 0,
            currGoodDesc: null,
            selectAllGoods: false,
        };
    },
    methods: {
        addItem() {
            if (!this.ifAllFieldsFilled()) return;
            const item = { id: new Date() * -1 };
            this.$set(item, "isNew", true);
            this.$set(item, "rowToSave", true);
            this.$set(item, "curr_expense_code", null);
            this.$set(item, "expense_code", null);
            this.$set(item, "summa", 0);
            this.$set(item, "recipient_ru", "");
            this.$set(item, "recipient_kk", "");
            this.$set(item, "purpose_ru", "");
            this.$set(item, "purpose_kk", "");
            this.$set(item, "justif_ru", "");
            this.$set(item, "justif_kk", "");
            this.$set(item, "itemToDelete", false);
            this.$set(item, "isHasDouble", false);
            this.$set(item, "isDataValid", false);
            this.$set(item, "file_hash", null);
            this.$set(item, "category_id", this.currCategory.category_id);
            this.goodsData.push(item);
            this.$emit("addOrderNumber", this.goodsData);
        }, // добавление записи в таблицу

        ifAllFieldsFilled() {
            const emptyField = this.goodsData.some(
                (item) => !item.expense_code || !item.summa
            );
            return !emptyField;
        },

        makeToast(variant = null, title, msg) {
            this.$bvToast.toast(msg, {
                title: title,
                variant: variant,
                solid: true,
            });
        },

        onDataChanged(item) {
            this.$set(item, "rowToSave", true);
            this.setIsDataValid(item);
        }, // переключения тригера при изменении данных товаров

        inputFixed(item, field, value, digit) {
            this.$set(item, field, value);
            this.$nextTick(() => {
                let newVal = parseFloat(value)
                    ? parseFloat(parseFloat(value).toFixed(digit))
                    : 0;
                if (newVal < 0) newVal = newVal * -1;
                this.$set(item, field, newVal);
                this.onDataChanged(item);
            });
        }, // форматирует введенное значение до digit цифр после запятой

        keyPress: function (event, pattern) {
            const regex = new RegExp(pattern);
            const key = String.fromCharCode(
                !event.charCode ? event.which : event.charCode
            );
            if (!regex.test(key)) {
                event.preventDefault();
                return false;
            }
        }, // вводит по заданному паттерну

        keyup13: function (event) {
            event.preventDefault();
            // Isolate the node that we're after
            const currentNode = event.target;
            // find all tab-able elements
            const allElements = document.querySelectorAll("input"); // area, object, select, [contenteditable]
            // Find the current tab index.
            const currentIndex = [...allElements].findIndex((el) =>
                currentNode.isEqualNode(el)
            );
            // select/focus the following element
            const targetIndex = (currentIndex + 1) % allElements.length;
            if (targetIndex < allElements.length) {
                allElements[targetIndex].select();
            }
        }, // enter работает как tab

        deleteItem(msg, row = false, index = false) {
            if (
                !this.variantAttribute ||
                (!row &&
                    this.goodsData.findIndex((itm) => itm.itemToDelete) === -1)
            )
                return;
            let deletingRow = null;
            this.$bvModal
                .msgBoxConfirm(`${msg}...`, {
                    title: this.getCommonText("confirm"),
                    size: "lg",
                    buttonSize: "sm",
                    okVariant: "danger",
                    okTitle: this.getCommonText("yes"),
                    cancelTitle: this.getCommonText("cancel"),
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        if (row) {
                            if ((!row.id || row.id < 0) && row.rowToSave) {
                                this.goodsData.splice(index, 1);
                            } else {
                                this.$emit("deleteRows", [row], "decodes");
                                deletingRow = this.goodsData.splice(index, 1);
                            }
                        } else {
                            const existingRowsToDel = [];
                            for (
                                let i = this.goodsData.length - 1;
                                i >= 0;
                                i--
                            ) {
                                if (this.goodsData[i].itemToDelete) {
                                    const rowId = this.goodsData[i].id;
                                    if (rowId >= 0) {
                                        existingRowsToDel.push(
                                            this.goodsData[i]
                                        );
                                    }
                                    this.goodsData.splice(i, 1);
                                }
                            }
                            if (existingRowsToDel.length) {
                                this.$emit(
                                    "deleteRows",
                                    existingRowsToDel,
                                    "decodes"
                                );
                            }
                            this.selectAllGoods = false;
                        }
                    }
                })
                .catch((error) => {
                    if (deletingRow)
                        this.goodsData = [
                            ...this.goodsData,
                            ...deletingRow,
                        ].sort((a, b) => a.id - b.id);
                    this.makeToast(
                        "danger",
                        this.getErrText("on_del"),
                        error.toString()
                    );
                });
        }, // удаление записи

        onFilesClick(item) {
            this.allFiles.forEach((item) => {
                if (item.new_file) this.$set(item, "new_file", false);
            });
            this.$refs.modalFilesManagement.showModal(item);
        },

        setNewFileHash(id, codes) {
            for (const good of this.goodsData) {
                if (good.id === id) {
                    this.$set(good, "file_hash", codes);
                    this.onDataChanged(good);
                    break;
                }
            }
        },

        onExpenseCodeChanged(item) {
            this.setExpenseCode(item);
            this.onDataChanged(item);
        },

        setExpenseCode(item) {
            if ('curr_expense_code' in item) {
                this.$set(item, 'expense_code', item.curr_expense_code.expense_code)
            }
        },

        onRowChanged(row) {
            this.$set(row, "rowToSave", true);
        },

        getDecodeControl(index) {
            return this.decodeControl[index] || {};
        },

        showEditModal(row, modalRef) {
            if (!row.expense_code) return;

            const modal = this.$refs[modalRef];
            if (modal) modal.showModal(row);
        },
        setIsDataValid(row) {
            if (row.expense_code && row.summa) {
                this.$set(row, "isDataValid", true);
            } else {
                this.$set(row, "isDataValid", false);
            }
        },
    },
    computed: {
        getFormText() {
            return this.setFormText("form_339.");
        },

        summaTotal() {
            const total = this.goodsData.reduce(
                (acc, item) => acc + item.summa,
                0
            );
            return total;
        },

        tableFields() {
            if (this.$i18n.locale) {
                return [
                    {
                        key: "action",
                        label: " ",
                    },
                    {
                        key: "order_number",
                        label: this.getCommonText("sn"),
                    },
                    {
                        key: "expense_code",
                        label: this.getFormText("name_code"),
                    },
                    {
                        key: "summa",
                        label: this.getFormText("cat_sum"),
                    },
                    {
                        key: "recipient",
                        label: this.getFormText("recipient"),
                    },
                    {
                        key: "purpose",
                        label: this.getFormText("purpose"),
                    },
                    {
                        key: "justif",
                        label: this.getFormText("justif"),
                    },
                    {
                        key: "files",
                        label: this.getCommonText("files"),
                    },
                    {
                        key: "more",
                        label: "",
                    },
                ];
            }
            return [];
        },
    },
};
</script>

<style scoped>
.form-01-144-multiselect-group {
    display: flex;
}

.form-01-144-multiselect-group .spinner-border {
    position: relative;
    right: 50px;
    opacity: 0.3;
    margin: auto;
    color: #7a87a0;
    z-index: 999;
}

.form-01-144-spinner {
    display: block;
    margin: auto;
    color: #7a87a0;
}

.goods-form-val-msg {
    font-size: 0.5rem;
    font-style: italic;
    color: red;
}

.ens-item-non-active {
    color: #6087a099;
}

.error ::v-deep .multiselect__tags {
    padding-left: 25px;
}
</style>
